<template>
  <div>
    <messagePopup
      dialog-title="易派客提醒您："
      :dialog-type="''"
      :center-dialog-visible="dialogVisible"
      :popup-width="'600px'"
      :show-close="false"
      :show-btn="false"
      @updateVisible="handleUpdateVisible"
      @resetPopupData="handleResetPopupData"
    >
      <div class="box">
        <div class="box_center">
          <div class="system_hint">
            <div class="system_title">系统提示：</div>
            <div class="system_p">
              您的密码已经使用超过三个月，请您修改密码，单独使用字母、数字、或符号作为密码存在安全隐患。请使用8-20位，不得包含用户名，且同时包含大小写字母、数字的混合密码。
            </div>
          </div>
          <el-form ref="form" :rules="rules" :model="form" label-width="110px">
            <el-form-item label="新密码：" prop="newPassword">
              <el-input
                v-model.trim="form.newPassword"
                maxlength="20"
                type="password"
                placeholder="请输入新密码"
              ></el-input>
            </el-form-item>
            <el-form-item label="重复新密码：" prop="repetitionPassword">
              <el-input
                v-model.trim="form.repetitionPassword"
                maxlength="20"
                type="password"
                placeholder="请重复输入新密码"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div class="next_btn">
          <div class="btn" @click="handleSubmit()">提交</div>
        </div>
      </div>
    </messagePopup>
  </div>
</template>

<script>
import { debounce } from '@/modules/projectA/utils/throttle.js';
import messagePopup from './e-messagePopup.vue';
import { callBackUrl } from '../../modules/projectA/api/config';
import api from '../../modules/projectA/api/nesting';
import api2 from '../../modules/projectA/api/login';
// import { JSEncrypt } from 'jsencrypt'
export default {
  components: {
    messagePopup,
  },
  data() {
    const reg =
      /(?![0-9A-Z!@#$_%^*()]+$)(?![0-9a-z!@#$_%^*()]+$)(?![a-zA-Z!@#$_%^*()]+$)[0-9A-Za-z!@#$_%^*()]{8,20}$/;
    const validatePass = (rule, value, callback) => {
      const { memberName } = this.$store.state.USERINFO;
      if (value === '') {
        callback(new Error('请输入密码'));
      } else if (
        memberName == value.toLowerCase() ||
        value.toLowerCase().indexOf(memberName) != -1
      ) {
        callback(new Error('密码不得包含用户名'));
      } else if (!reg.test(value)) {
        callback(new Error('密码应是8-20位必须同时包括大小写字母及数字！'));
      } else if (this.passwordState == '101') {
        callback(new Error('密码过于简单，请重新设置密码'));
      } else if (this.passwordState == '102') {
        callback(new Error('不能使用前5次使用过的密码'));
      } else {
        if (this.form.repetitionPassword !== '') {
          this.$refs.form.validateField('repetitionPassword');
        }
        callback();
      }
    };
    const validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.form.newPassword) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    return {
      gateway:
        'https://uat-gateway.epec.com/ssoLogin/callback?from=CORP_WEB_SITE',
      afterLoginUrl: `&afterLoginUrl=${callBackUrl}`,
      dialogVisible: false,
      form: {
        newPassword: '',
        repetitionPassword: '',
      },
      rules: {
        newPassword: [
          { required: true, validator: validatePass, trigger: 'blur' },
        ],
        repetitionPassword: [
          { required: true, validator: validatePass2, trigger: 'blur' },
        ],
      },
      userInfo: {},
      passwordState: '',
      // publicKey: ''
    };
  },
  computed: {},
  created() {
    this.getContextObjectAndRemark();
  },
  mounted() {},

  methods: {
    handleSubmit() {
      debounce(() => {
        if (this.form.repetitionPassword) {
          // 弱口令
          const params = {
            memberId: this.$store.state.USERINFO.memberId,
            password: this.form.repetitionPassword,
          };
          api.weakPasswordCheck(params).then((res) => {
            console.log(res.data.status);
            if (res.data.status != 'ok') {
              this.passwordState = res.data.status;
            }
            this.submit();
          });
        } else {
          this.submit();
        }
      }, 1000);
    },

    // 提交
    submit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.form.newPassword === this.form.repetitionPassword) {
            // let params = {
            //   memberId: this.userInfo.memberId,
            //   newPassword: this.encryptedData(this.publicKey,this.form.repetitionPassword),
            // }
            const params = {
              memberId: this.userInfo.memberId,
              newPassword: this.form.repetitionPassword,
            };
            api.changePassword(params).then((res) => {
              if (res.code == '200' && res.data?.returnResult) {
                this.$message.success('修改成功，请重新登录');
                const timer = setTimeout(() => {
                  this.longOut();
                  clearTimeout(timer);
                }, 2000);
                this.dialogVisible = false;
              } else {
                this.$message.error('修改失败');
                this.dialogVisible = false;
              }
            });
          } else {
            this.$message.error('两次密码不一样');
          }
        } else {
          this.passwordState = '';
          console.log('error submit!!');
          return false;
        }
      });
    },

    // // 密码加密
    // encryptedData(publicKey, data) {
    //   // 新建JSEncrypt对象
    //   let encryptor = new JSEncrypt();
    //   // 设置公钥
    //   encryptor.setPublicKey(publicKey);
    //   // 加密数据
    //   return encryptor.encrypt(data);
    // },

    handleResetPopupData() {
      this.dialogVisible = false;
      this.form.newPassword = '';
      this.form.repetitionPassword = '';
    },
    handleUpdateVisible() {
      this.dialogVisible = false;
      this.form.newPassword = '';
      this.form.repetitionPassword = '';
    },

    async getContextObjectAndRemark() {
      const userInfo = this.$store.state.USERINFO;
      if (userInfo?.memberSource === 'zhongjian') return;
      const res = await api.getContextObjectAndRemark({ bussType: '101' });
      if (res.code == '200') {
        this.userInfo = this.$store.state.USERINFO;
        if (
          res.data.returnResult == 'needToEditPwd' ||
          res.data.returnResult == 'needEditPwd'
        ) {
          this.dialogVisible = true;
          // this.getPublicKey();
        } else {
          this.dialogVisible = false;
        }
      }
    },

    // 修改完重新登录
    async longOut() {
      const parmas = {
        callBackUrl: this.epecLoginUrl(),
      };
      const res = await api2.mallLoginOut(parmas);
      if (res.code == 200) {
        localStorage.clear();
        this.$cookies.remove('epecToken', '/', 'epec.com');
        window.open(res.data, '_self');
      }
    },
    epecLoginUrl() {
      return encodeURIComponent(this.gateway + this.afterLoginUrl);
    },

    // // 密码加密
    // async getPublicKey() {
    //   let res = await api2.getPublicKey();
    //   if (res.code == 200) {
    //     this.publicKey = res.data.publicKey;
    //   }
    // }
  },
};
</script>

<style lang="scss" scoped>
.box {
  padding-top: 30px;
  .box_center {
    width: 100%;
    box-sizing: border-box;
    padding: 0 70px;
    font-size: 14px;
    color: #333333;
    margin-bottom: 20px;
    .system_hint {
      width: 100%;
      height: 60px;
      display: flex;
      margin-bottom: 20px;
      .system_title {
        width: 98px;
        height: 100%;
        margin-right: 10px;
        display: flex;
        justify-content: flex-end;
      }
      .system_p {
        width: 340px;
        height: 100%;
        word-wrap: break-word;
        text-align: justify;
      }
    }
  }
  .next_btn {
    width: 100%;
    border-top: 1px solid #d9d9d9;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    .btn {
      cursor: pointer;
      width: 80px;
      height: 30px;
      display: flex;
      justify-content: center;
      align-items: center;
      background: #2587ff;
      color: #fff;
      &:hover,
      :active {
        background-color: #126edf;
      }
    }
  }
}
::v-deep.el-input__inner {
  width: 300px;
  border-radius: 0;
  color: #333;
}
::v-deep.el-input--small .el-input__inner {
  border-radius: 0;
}
::v-deep.el-form-item__label {
  font-size: 14px;
  color: #333;
}
</style>
